exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/@babel/polyfill/~/core-js/modules/_wks-ext.js
// module id = 170
// module chunks = 92